import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	roadmapAccess: {
		id: 'polaris-component-collection-configure-sidebar.default-content.header.permissions-modal.roadmap-access',
		defaultMessage: 'Roadmap restrictions',
		description: 'Label for Roadmap restrictions button',
	},
});
